module.exports = __webpack_public_path__ + "img/prolongation-bg-3.a8babe8.png";